import React from 'react';
import { VStack } from '@chakra-ui/react';
import JobOpeningListItem from './JobOpeningListItem';
import JobOpeningPagination from './JobOpeningPagination';

const JobOpeningList = ({ jobs, currentPage, totalPages, jobsPerPage, onPageChange, totalJobs, fromInternship }) => {
  // Pagination logic
  const startIdx = (currentPage - 1) * jobsPerPage;
  const endIdx = startIdx + jobsPerPage;
  const jobsToShow = jobs.slice(startIdx, endIdx);

  return (
    <>
      <VStack spacing={4} align="stretch">
        {jobsToShow.length === 0 ? (
          <div>No jobs found.</div>
        ) : (
          jobsToShow.map(job => <JobOpeningListItem key={job.id} job={job} fromInternship={fromInternship} />)
        )}
      </VStack>
      <JobOpeningPagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalJobs={totalJobs}
        jobsPerPage={jobsPerPage}
        onPageChange={onPageChange}
      />
    </>
  );
};

export default JobOpeningList; 